var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M437.02,437.019c-99.974,99.974-262.064,99.974-362.04,0c-99.974-99.974-99.974-262.065,0.001-362.04 c99.974-99.974,246.323-84.233,346.297,15.742C521.251,190.695,536.993,337.045,437.02,437.019z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M74.981,74.98c99.974-99.974,262.063-99.972,362.039,0.001c99.974,99.974,99.974,262.064,0,362.039"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "195.642,345.044 199.786,357.799 213.197,357.799 202.347,365.681 206.492,378.436  195.642,370.553 184.792,378.436 188.936,365.681 178.087,357.799 191.497,357.799  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "161.391,222.609 168.3,243.867 190.65,243.867 172.567,257.004 179.474,278.262  161.391,265.123 143.309,278.262 150.217,257.004 132.133,243.867 154.485,243.867  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "161.391,378.436 168.298,399.694 190.65,399.694 172.565,412.83 179.474,434.088  161.391,420.949 143.309,434.088 150.215,412.83 132.133,399.694 154.482,399.694  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "226.741,278.262 233.65,299.52 256,299.52 237.917,312.656 244.824,333.914  226.741,320.775 208.659,333.914 215.567,312.656 197.484,299.52 219.835,299.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "96.04,278.262 102.949,299.52 125.298,299.52 107.216,312.656 114.122,333.914  96.04,320.775 77.957,333.914 84.866,312.656 66.782,299.52 89.133,299.52  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M428.549,189.561c-11.441-11.441-26.307-18.2-42.282-19.361l47.82-37.193 c-19.045-19.045-44.571-27.646-69.479-25.827c-2.982-10.716-8.667-20.838-17.094-29.265l-18.889,37.778 c-1.239-2.258-2.808-4.383-4.722-6.296c-10.868-10.867-28.486-10.867-39.352,0s-10.868,28.485,0,39.352 c1.913,1.913,4.039,3.482,6.297,4.722l-37.778,18.889c8.429,8.43,18.558,14.119,29.28,17.099 c-1.825,24.908,6.767,50.43,25.813,69.476l41.78-53.718c3.143-3.095,7.294-4.804,11.71-4.804c4.46,0,8.652,1.736,11.805,4.891 c3.154,3.153,4.891,7.346,4.891,11.805c0,4.46-1.737,8.652-4.891,11.806l15.742,15.742c7.357-7.358,11.41-17.141,11.41-27.547 c0-8.514-2.716-16.608-7.73-23.3c7.306,1.951,14.211,5.773,19.931,11.494c17.36,17.359,17.36,45.605,0,62.963l15.742,15.742 c12.613-12.614,19.56-29.384,19.56-47.223C448.11,218.945,441.162,202.175,428.549,189.561z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPg);
export default __webpack_public_path__ + "static/media/pg.7cda0dfa100cfacdff6c4463d251e513.svg";
export { ForwardRef as ReactComponent };